(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbf-lp-about"] && !Shopify.designMode) return;
  try {
    

  // Queue Lightbox
  $('.bbf-lp-gallery__lightbox').simpleLightbox();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orchard-lp-about"] && !Shopify.designMode) return;
  try {
    

  // Queue Lightbox
  $('.orchard-lp-gallery__lightbox').simpleLightbox();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orchard-lp-slider--mobile"] && !Shopify.designMode) return;
  try {
    
  // Slick Slider 
  $('#orchard-mobile_slider__slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 690,
        settings: {
          dots: false,
          slidesToShow: 1
        }
      }
    ]
  });

  // Queue Lightbox
  $('.orchard-lp-slider--mobile__lightbox').simpleLightbox();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbl-roster-rt"] && !Shopify.designMode) return;
  try {
    
  // Slick Slider 
  $('#tnp-roster__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 690,
        settings: {
          dots: false,
          slidesToShow: 1
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbl-roster"] && !Shopify.designMode) return;
  try {
    
  // Slick Slider 
  $('#tnp-roster__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 690,
        settings: {
          dots: false,
          slidesToShow: 1
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();
})();
